/**
 * PasswordRequirementList — checklist of password requirements with pass/fail icons.
 * Used by RegisterPage and ResetPasswordForm.
 */
import { Check, X } from "lucide-react";
import { PASSWORD_KEYS } from "@/shared/lib/design-tokens";
import { getEffectiveDir } from "@/shared/lib/direction";

interface PasswordRequirementListProps {
  met: boolean[];
  translate: (key: string) => string;
  isRTL?: boolean;
  /** Override default PASSWORD_KEYS — needed when RegisterPage uses different i18n keys */
  keys?: readonly string[];
}

export function PasswordRequirementList({
  met,
  translate,
  keys = PASSWORD_KEYS,
}: PasswordRequirementListProps) {
  return (
    <ul className="space-y-1 mt-2" aria-label="Password requirements">
      {keys.map((key, i) => (
        <li key={key} className="flex items-center gap-2">
          {met[i] ? (
            <Check
              size={12}
              className="shrink-0"
              style={{ color: "var(--color-success)" }}
            />
          ) : (
            <X
              size={12}
              className="shrink-0"
              style={{ color: "var(--text-tertiary)" }}
            />
          )}
          <span
            className="text-xs"
            style={
              met[i]
                ? { color: "var(--color-success)" }
                : { color: "var(--color-muted-text)" }
            }
            dir={getEffectiveDir()}
          >
            {translate(key)}
          </span>
        </li>
      ))}
    </ul>
  );
}